import React from "react";
import "../styles/userProfile.css";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { AiOutlineRight } from "react-icons/ai";

import {
  FaUserEdit,
  FaFileAlt,
  FaVideo,
  FaStore,
  FaBoxOpen,
  FaReceipt,
  FaMoneyBillWave,
  FaWallet,
  FaUserShield,
} from "react-icons/fa";

export default function UserProfile() {
  const { user, googleLogout } = useAuth();
  const navigate = useNavigate();

  const ADMIN_UID = "jKahzGJWb2hRmWWrppjWCiazpFd2";

  return (
    <div className="profile-page">

      {/* =========================================================
          PROFILE LINKS
      ========================================================= */}
      <div className="pf-links">

        {/* Wallet */}
        <div
          className="pf-link-item"
          onClick={() => navigate("/wallet")}
        >
          <div className="pf-link-left">
            <FaWallet className="pf-link-icon" />
            <span>Wallet</span>
          </div>

          <AiOutlineRight className="pf-link-arrow" />
        </div>


        {/* Edit Profile */}
        <div
          className="pf-link-item"
          onClick={() => navigate("/user/settings")}
        >
          <div className="pf-link-left">
            <FaUserEdit className="pf-link-icon" />
            <span>Edit Profile</span>
          </div>

          <AiOutlineRight className="pf-link-arrow" />
        </div>


        {/* My Posts */}
        <div
          className="pf-link-item"
          onClick={() => navigate("/user/posts")}
        >
          <div className="pf-link-left">
            <FaFileAlt className="pf-link-icon" />
            <span>My Posts</span>
          </div>

          <AiOutlineRight className="pf-link-arrow" />
        </div>


        {/* My Videos */}
        <div
          className="pf-link-item"
          onClick={() => navigate("/user/videos")}
        >
          <div className="pf-link-left">
            <FaVideo className="pf-link-icon" />
            <span>My Videos</span>
          </div>

          <AiOutlineRight className="pf-link-arrow" />
        </div>


        {/* My Shop */}
        <div
          className="pf-link-item"
          onClick={() => navigate("/user/shop")}
        >
          <div className="pf-link-left">
            <FaStore className="pf-link-icon" />
            <span>My Shop</span>
          </div>

          <AiOutlineRight className="pf-link-arrow" />
        </div>


        {/* My Orders */}
        <div
          className="pf-link-item"
          onClick={() => navigate("/orders")}
        >
          <div className="pf-link-left">
            <FaBoxOpen className="pf-link-icon" />
            <span>My Orders</span>
          </div>

          <AiOutlineRight className="pf-link-arrow" />
        </div>


        {/* Instore Bills */}
        <div
          className="pf-link-item"
          onClick={() => navigate("/user/bills")}
        >
          <div className="pf-link-left">
            <FaReceipt className="pf-link-icon" />
            <span>Instore Bills</span>
          </div>

          <AiOutlineRight className="pf-link-arrow" />
        </div>


        {/* EMI */}
        <div
          className="pf-link-item"
          onClick={() => navigate("/user/loans")}
        >
          <div className="pf-link-left">
            <FaMoneyBillWave className="pf-link-icon" />
            <span>EMI</span>
          </div>

          <AiOutlineRight className="pf-link-arrow" />
        </div>


        {/* Admin Dashboard */}
        {user?.uid === ADMIN_UID && (
          <div
            className="pf-link-item"
            onClick={() => navigate("/admin")}
          >
            <div className="pf-link-left">
              <FaUserShield className="pf-link-icon" />
              <span>Admin Dashboard</span>
            </div>

            <AiOutlineRight className="pf-link-arrow" />
          </div>
        )}

      </div>


      {/* =========================================================
          LOGOUT
      ========================================================= */}
      <button
        className="pf-logout"
        onClick={googleLogout}
      >
        Logout
      </button>

    </div>
  );
}